import { render, staticRenderFns } from "./session.vue?vue&type=template&id=bc3507e8&"
import script from "./session.vue?vue&type=script&lang=ts&"
export * from "./session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports